import { getUiBasePathPrefix } from '@/utils/basePath';

export const getTenantShortNameFromUrl = (url: string) => {
  const prefix = getUiBasePathPrefix();
  const pathWithoutBase = prefix && url.startsWith(prefix) ? url.slice(prefix.length) : url;
  return pathWithoutBase.split('/')[2];
};
